var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCount24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8042 20.6969H6.3042V14.3465H3.8042V20.6969ZM7.5542 20.9575L7.54932 21.0644C7.50142 21.5548 7.12717 21.945 6.65674 21.9949L6.5542 22H3.5542L3.45166 21.9949C2.94753 21.9414 2.5542 21.4972 2.5542 20.9575V14.0859C2.5542 13.5102 3.00191 13.0435 3.5542 13.0435H6.5542C7.10648 13.0435 7.5542 13.5102 7.5542 14.0859V20.9575Z",
    fill: "#212B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20.6969H13.25V3.30306H10.75V20.6969ZM14.5 20.9575L14.4951 21.0644C14.4472 21.5548 14.073 21.945 13.6025 21.9949L13.5 22H10.5L10.3975 21.9949C9.92703 21.945 9.55278 21.5548 9.50488 21.0644L9.5 20.9575V3.04245C9.5 2.46672 9.94772 2 10.5 2H13.5C14.0523 2 14.5 2.46672 14.5 3.04245V20.9575Z",
    fill: "#212B36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6958 20.6969H20.1958V10.7855H17.6958V20.6969ZM21.4458 20.9575L21.4409 21.0644C21.393 21.5548 21.0188 21.945 20.5483 21.9949L20.4458 22H17.4458L17.3433 21.9949C16.8728 21.945 16.4986 21.5548 16.4507 21.0644L16.4458 20.9575V10.5249C16.4458 9.94916 16.8935 9.48244 17.4458 9.48244H20.4458C20.9981 9.48244 21.4458 9.94916 21.4458 10.5249V20.9575Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCount24);
export default __webpack_public_path__ + "static/media/icon_count_24.46f705339548bbc3a1e77adaeb4a2b64.svg";
export { ForwardRef as ReactComponent };